import { renderKoTextCell } from '~/components/templates/listPageDataTable';
import { html, LpTable } from '~/design-system';
export function renderRecruitingTextCell({ column, binding, className, clampLines, titleBinding, }) {
    return renderKoTextCell({
        column,
        binding,
        className,
        contentClassName: clampLines ? 'lp-table_cell-content--clamp' : undefined,
        contentStyle: clampLines ? `--lp-table-cell-line-clamp: ${clampLines};` : undefined,
        titleBinding,
    });
}
export function renderRecruitingStatusCell({ column, textBinding, cssBinding, className, badgeClassName, }) {
    const statusClass = badgeClassName
        ? `task-status ${badgeClassName}`
        : 'task-status';
    return LpTable.Cell({
        column,
        className,
        children: html `
            <span
                class="${statusClass}"
                data-bind="
                    text: ${textBinding},
                    css: { ${cssBinding} }
                "
            ></span>
        `,
    });
}
